import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React, { useState } from "react";

let ReactQueryDevtools = null;
if (process.env.NODE_ENV === "development") {
  try {
    ReactQueryDevtools = require("@tanstack/react-query-devtools").ReactQueryDevtools;
  } catch (e) {
    ReactQueryDevtools = null;
  }
}

export const QueryProvider = ({ children }) => {
  const [queryClient] = useState(() => {
    return new QueryClient({
      defaultOptions: {
        queries: {
          refetchOnWindowFocus: false,
          refetchOnMount: false,
          refetchOnReconnect: false,
          retry: false,
          cacheTime: 0,
          staleTime: 5 * 60 * 1000, // 5 minutes
        },
      },
    });
  });

  return (
    <QueryClientProvider client={queryClient}>
      {children}

      {ReactQueryDevtools ? <ReactQueryDevtools initialIsOpen={false} /> : null}
    </QueryClientProvider>
  );
};
